import React from "react";
import { Layout } from "../components/web-layout/layout";

export default class Privacy extends React.Component {
    render() {
        return (
            <Layout>
                <h1>Our Privacy Policy</h1>
                <p>
                    Welcome to HabitNu, a website (the "HabitNu Site" or the
                    "Site") owned and operated by Prana Diabetes, Inc. ("Prana
                    Diabetes," the "Company," "we," "us" or "our") to provide
                    information to help manage diabetes through interactive
                    monitoring of diet, exercise and &nbsp;lifestyle coaching
                    (the "services").
                </p>
                <p>
                    The HabitNu Site is intended for use by consumers
                    (non-professionals) for non-commercial personal, family or
                    household purposes. This Privacy Policy also applies to the
                    HabitNu Site and any mobile device applications of the Site.
                </p>
                <p>
                    PLEASE READ THIS PRIVACY POLICY CAREFULLY BEFORE USING THE
                    SITE.
                </p>
                <p>
                    By using the Site, you signify your assent to this Privacy
                    Policy. If you do not agree to this Privacy Policy, do not
                    use the Site.
                </p>
                <p>
                    We may revise and update this Privacy Policy at any time.
                    Your continued usage of the HabitNu Site will mean you
                    accept those changes.
                </p>
                <p>
                    Prana Diabetes, Inc. understands how important the privacy
                    of personal information is to our users. We understand that
                    your privacy matters and we respect your privacy choices.
                    This
                </p>
                <p> </p>
                <p>
                    Privacy Policy is intended to provide you with the following
                    information:
                </p>
                <ul>
                    <li>
                        <p>What information we collect about you</p>
                    </li>
                    <li>
                        <p>What choices you have about your information</p>
                    </li>
                    <li>
                        <p>How we use your information</p>
                    </li>
                    <li>
                        <p>
                            How and with whom we may share the information we
                            have about you
                        </p>
                    </li>
                    <li>
                        <p>How we protect your information</p>
                    </li>
                    <li>
                        <p>How to contact us with questions or concerns</p>
                    </li>
                </ul>
                <p> </p>
                <h2>Summary of Privacy Policy</h2>
                <h3>Information Collected About You</h3>
                <p>
                    Prana Diabetes Inc. will not share your data with anyone
                    except what is necessary to implement our program, which is
                    modeled after the Diabetes Prevention Program developed by
                    the Centers for Disease Control. Group support and support
                    from a lifestyle coach are central to this program. If you
                    do not want your information to be shared with a coach or to
                    the members of your team please contact Prana Diabetes Inc
                    dba HabitNu customer support.
                </p>
                <p>
                    We may collect "Personal Information" about you – such as
                    your telephone number, email address, or health information
                    – in the following ways:
                </p>
                <ul>
                    <li>
                        <p>
                            When you register for or update an existing profile
                            on our Site;
                        </p>
                    </li>
                    <li>
                        <p>
                            When you use certain interactive tools and services;
                        </p>
                    </li>
                    <li>
                        <p>
                            When you sign-up for newsletters or other
                            communications from us;
                        </p>
                    </li>
                    <li>
                        <p>When you participate in an online survey; or</p>
                    </li>
                    <li>
                        <p>
                            When you provide personal information in a community
                            area or other public forum.
                        </p>
                    </li>
                </ul>
                <p>
                    We may collect "Non-Personal Information" – information that
                    cannot be used to identify you – via Cookies, Web Beacons,
                    mobile device applications and from external sources, even
                    if you have not registered with or provided any Personal
                    Information to Prana Diabetes.
                </p>
                <p> </p>
                <h3>What Choices Do I Have?</h3>
                <p>
                    If you do not want your Personal Information used by Prana
                    Diabetes as provided in this Privacy Policy, you should not
                    register as a member or for any specific tool or application
                    that collects Personal Information. You may correct, update
                    or review Personal Information you have submitted through
                    registration, tools and applications by signing in and
                    updating your registration information, or by using the
                    "Contact" page to send a message directly to Prana Diabetes
                    administrators to do same. If you have registered and no
                    longer want Prana Diabetes to use your Personal Information,
                    you should delete your information as described in this
                    Privacy Policy. Most browser software can be set to reject
                    Cookies.
                </p>
                <h3>How Information Collected About You Is Used</h3>
                <p>We may use information we collect about you to:</p>
                <ul>
                    <li>
                        <p>Administer your account;</p>
                    </li>
                    <li>
                        <p>
                            Provide you with access to particular tools and
                            services;
                        </p>
                    </li>
                    <li>
                        <p>
                            Respond to your inquiries and send administrative
                            communications with you and your team members
                        </p>
                    </li>
                    <li>
                        <p>
                            Obtain your feedback on our Site and our offerings;
                        </p>
                    </li>
                    <li>
                        <p>Statistically analyze user behavior and activity;</p>
                    </li>
                    <li>
                        <p>
                            Provide you with more relevant content and
                            advertisements;
                        </p>
                    </li>
                    <li>
                        <p>Conduct research and measurement activities; or</p>
                    </li>
                    <li>
                        <p>
                            Send you personalized emails or secure electronic
                            messages pertaining to your health interests,
                            including news, announcements, reminders and
                            opportunities.
                        </p>
                    </li>
                </ul>
                <p>
                    We may combine Personal and Non-Personal Information
                    collected by Prana Diabetes about you, and may combine this
                    information with information from external sources. Third
                    parties may also use Non-Personal Information in order to
                    display advertising that reflects the interests and
                    preferences of our user community.
                </p>
                <h3>With Whom Do We Share Your Information?</h3>
                <p>
                    Outside the purpose of administering the lifestyle change
                    program,&nbsp;Prana Diabetes will not disclose any Personal
                    Information about you unless specifically agreed to by you
                    or:
                </p>
                <ul>
                    <li>
                        <p>
                            To comply with legal requirements, such as a law,
                            regulation, search warrant, subpoena, or court
                            order;
                        </p>
                    </li>
                    <li>
                        <p>
                            In the event of a corporate change in control
                            resulting from, for example, a merger, a sale of
                            assets, or bankruptcy; or
                        </p>
                    </li>
                    <li>
                        <p>
                            In special cases, such as in response to a physical
                            threat to you or others.
                        </p>
                    </li>
                </ul>
                <p>
                    Prana Diabetes does not make your Personal Information
                    available to third parties for their marketing purposes.
                </p>
                <h3>Contact Us</h3>
                <p>
                    Please send us an email using the "Contact" page on our Site
                    if you have any questions about this Privacy Policy or the
                    Personal Information we maintain about you.
                </p>
                <p> </p>
                <h2>Privacy Policy</h2>
                <h3>Information Collected About You:</h3>
                <h3>Personal Information</h3>
                <p>
                    If you choose to register or update an existing member
                    profile with HabitNu site by Prana Diabetes or access
                    certain functionality on the Site, you may be required to
                    submit Personal Information. "Personal Information" means
                    information that we can use to identify or contact you, such
                    as your telephone number or email address. Some of our
                    interactive tools and services may request you to submit
                    health information, which would also be considered Personal
                    Information. You are responsible for ensuring the accuracy
                    of the Personal Information that you submit to us.
                    Inaccurate information will affect your experience when
                    using the Site and tools and our ability to contact you as
                    described in this Privacy Policy. Inaccurate information
                    will not prohibit you from using the Site.
                </p>
                <h3>Registration</h3>
                <p>
                    Access to some HabitNu interactive tools and services may be
                    limited to users who have registered. Some of our tools do
                    not retain your Personal Information, while others store
                    your Personal Information in accordance with this Privacy
                    Policy. You may also be asked to provide authorization for
                    uses of personal information in addition to what is in this
                    Privacy Policy when you use certain tools. In such event,
                    Prana Diabetes will not make any use of your personal
                    information in ways other than as provided in this Privacy
                    Policy unless you provide such additional consent in
                    connection with the specific tool at the time you submit
                    Personal Information in order to use the tool. The Site
                    allows you to gather, store, manage and share your Personal
                    Information and provides tools and services to better manage
                    your health and the health of your family. We use the
                    Personal Information that you provide to send you
                    personalized emails from your lifestyle coach to you and
                    your team members in the Big Marker private forum assigned
                    to you.
                </p>
                <h3>Newsletters &amp; Emails to You</h3>
                <p>
                    At registration and at various times as you use the HabitNu
                    Site, you will be given the option of providing us with
                    Personal Information in order to receive recurring
                    informational/promotional newsletters – such as a newsletter
                    relating to a specific health concern – via email from Prana
                    Diabetes and/or directly from third parties.
                </p>
                <p>
                    When you sign up for our email newsletters on the Site or at
                    any time, you can choose to opt out of receiving additional
                    promotional newsletters from us or our sponsors.
                </p>
                <p>You can unsubscribe from a newsletter by:</p>
                <ul>
                    <li>
                        <p>
                            Following the directions included at the bottom of
                            the newsletter.
                        </p>
                    </li>
                    <li>
                        <p>
                            Logging in to the Site and using the "Contact" page
                            to request the newsletter not be sent to you
                            anymore.
                        </p>
                    </li>
                </ul>
                <h3>Market Research</h3>
                <p>
                    From time to time, we may conduct online research surveys
                    through email invitations, pop-up surveys and online focus
                    groups. When participating in a survey, we may ask you to
                    enter Personal Information. The Personal Information you
                    submit in a survey may be used by Prana Diabetes for
                    research and measurement purposes including measuring the
                    effectiveness of content, advertising or programs. When our
                    market research surveys collect Personal Information we will
                    not knowingly accept participants who are under the age of
                    13. Market research surveys conducted by or on behalf of
                    Prana Diabetes will contain a link to this Privacy Policy.
                </p>
                <h3>Public Forums</h3>
                <p>
                    Prana Diabetes may feature community areas and public forums
                    where users with similar interests or medical concerns can
                    share information and support one another or where users can
                    post questions for experts to answer. We may also offer
                    online discussions moderated by healthcare experts. Such
                    communities will be open to the public and should not be
                    considered private.
                </p>
                <p>
                    Any information (including Personal Information) you share
                    in any online community area of the Site is by design open
                    to the public and is not private. You should think carefully
                    before posting any Personal Information in any public forum.
                    What you post can be seen, disclosed to or collected by
                    third parties and may be used by others in ways we cannot
                    control or predict, including to contact you for
                    unauthorized purposes. As with any public forum on any site,
                    the information you post may also show up in third-party
                    search engines.
                </p>
                <p>
                    If you mistakenly post Personal Information in our public
                    areas and would like it removed, you can send us an email to
                    request that we remove it by using the "Contact" page on the
                    Site. In some cases, we may not be able to remove your
                    Personal Information.
                </p>
                <h3>Emails You Send to Prana Diabetes</h3>
                <p>
                    This Privacy Policy does not apply to information, content,
                    business information, ideas, concepts or inventions that you
                    send to us by email. If you want to keep content or business
                    information, ideas, concepts or inventions private or
                    proprietary, do not send them in an email to Prana Diabetes.
                </p>
                <h3>Non-Personal Information</h3>
                <p>
                    Even if you do not register with or provide any Personal
                    Information to Prana Diabetes, we collect Non-Personal
                    Information about your use of the HabitNu Site.
                    "Non-Personal Information" means information that we cannot
                    use to identify or contact you. We may also acquire
                    Non-Personal Information about our users from external
                    sources. While you may use some of the functionality of the
                    Site without registration, many of the specific tools and
                    services on the HabitNu Site require that you register on
                    the Site.
                </p>
                <h3>Cookies and Web Beacons</h3>
                <p>
                    We collect Non-Personal Information about your use of the
                    HabitNu Site through the use of Cookies and Web Beacons.
                    "Cookies" are small data files that are stored on the hard
                    drive of the computer you use to view a web site. Every
                    computer that accesses the HabitNu Site is assigned a
                    different cookie by our Site. "Web Beacons" are graphic
                    image files imbedded in a web page typically used to monitor
                    activity on a web page and send back to its home server
                    (which can belong to the host site, a network advertiser or
                    some other third party) information from your browser, such
                    as the IP address, the URL of the page on which the beacon
                    is located, the type of browser that is accessing the site
                    and the ID number of any Cookies on your computer previously
                    placed by that server.
                </p>
                <p>
                    Third parties under contract with Prana Diabetes may use
                    Cookies or Web Beacons to collect Non-Personal Information
                    about your usage of the HabitNu Site, including which health
                    topics you have viewed. These third party advertising
                    service providers may use this information, on our behalf,
                    to help us deliver advertising on the HabitNu Site based on
                    your browsing activity on our Site. We may further tailor
                    the advertising based on additional Non-Personal Information
                    to the extent known by Prana Diabetes or these third
                    parties.
                </p>
                <h3>
                    Non-Personal Information Collected by Third Parties Not
                    Acting on Behalf of Prana Diabetes
                </h3>
                <p>
                    We may work with third parties to display advertising that
                    reflects the interests and preferences of our user
                    community. Sponsors or advertisers on the HabitNu Site may
                    use their own Cookies, Web Beacons or other online tracking
                    technologies in the banner advertisements served on the
                    HabitNu Site and in emails, special promotions or
                    newsletters we send you. Their advertisements may be
                    displayed on our Site or on other sites that you visit after
                    you visit our Site. Some advertisers use companies other
                    than Prana Diabetes to serve their ads and to monitor users'
                    responses to ads, and these companies ("Ad Servers") may
                    also collect Non-Personal Information through the use of
                    Cookies or Web Beacons on the HabitNu Site.
                </p>
                <p>
                    We do not control how third parties use Cookies or Web
                    Beacons or how they manage the Non-Personal Information they
                    gather through the use of these technologies on the HabitNu
                    Site. However, our advertising policy is to prohibit
                    sponsors, advertisers and Ad Servers who collect cookie or
                    web beacon information through the HabitNu Site from
                    collecting any Personal Information from the HabitNu Site
                    without your consent. Our Company's policy is also to
                    prohibit advertisers from linking any Non-Personal
                    Information collected by them on the HabitNu Site to
                    Personal Information they or others collect in other ways or
                    from other sites except as may be described in connection
                    with a particular program.
                </p>
                <h3>What Choices Do I Have?</h3>
                <h3>Updating/Removing Your Personal Information</h3>
                <p>
                    If you do not want your Personal Information used by Prana
                    Diabetes as provided in this Privacy Policy, you should not
                    register as a member or for any specific tool or application
                    that collects Personal Information. You can correct, update
                    or review Personal Information you have previously submitted
                    by going back to the specific tool or application,
                    logging-in and making the desired change. You can also
                    update any Personal Information you have submitted by
                    contacting us using the contact information listed below.
                </p>
                <p>
                    If you have registered and desire to delete any of your
                    Personal Information you have provided to us from our
                    systems please contact us using the contact information
                    listed below. Upon your request, we will delete your
                    Personal Information from our active databases and where
                    feasible from our back-up media. You should be aware that it
                    is not technologically possible to remove each and every
                    record of the information you have provided to the HabitNu
                    Site from our servers.
                </p>
                <p>
                    If you decide that you would prefer not to receive
                    personalized email or secure electronic messages from the
                    HabitNu Site, you may "Opt-out" and change your email
                    preference or following the unsubscribe instructions
                    included in each promotional email.
                </p>
                <h3>Cookies</h3>
                <p>
                    Most browser software can be set to reject Cookies. Most
                    browsers offer instructions on how to reset the browser to
                    reject Cookies in the "Help" section of the toolbar. If you
                    reject our Cookies, certain of the functions and
                    conveniences of the HabitNu Site may not work properly but
                    you do not have to accept our Cookies in order to
                    productively use the HabitNu Site.
                </p>
                <h3>How Information Collected About You Is Used</h3>
                <p>We use the Information we collect about you to:</p>
                <ul>
                    <li>
                        <p>administer your account,</p>
                    </li>
                    <li>
                        <p>
                            provide you with access to particular tools and
                            services,
                        </p>
                    </li>
                    <li>
                        <p>
                            respond to your inquiries you send to us and to send
                            you administrative communications about the Site,
                        </p>
                    </li>
                    <li>
                        <p>
                            complete requests and transactions requested by you,
                        </p>
                    </li>
                    <li>
                        <p>
                            btain your feedback about the Site or our offerings,
                        </p>
                    </li>
                    <li>
                        <p>
                            statistically analyze user behavior and activity
                            including how frequently areas of the Site are
                            visited and how many emails are received and opened,
                        </p>
                    </li>
                    <li>
                        <p>
                            provide you with more relevant content or
                            advertising both on the HabitNu Site or on other web
                            sites that you visit after you leave the HabitNu
                            Site; and
                        </p>
                    </li>
                    <li>
                        <p>
                            conduct research and measurement activities,
                            including those described below.
                        </p>
                    </li>
                </ul>
                <p>
                    We may combine Personal and Non-Personal Information which
                    we collect about you, and we may combine this information
                    with information from external sources.We have the ability
                    to use Personal Information that you provide to send you
                    personalized emails or secure electronic messages. During
                    registration or at any time, you have the option of choosing
                    whether or not you wish to receive emails pertaining to your
                    health interests, including news, announcements, reminders
                    and opportunities.
                </p>
                <p>
                    We also use Cookies in order to enable us to conduct surveys
                    for our own use and on behalf of our advertisers. These
                    Cookies are used to determine whether you have seen certain
                    content or advertising so that we may request your opinions.
                    We may also use Cookies to authenticate respondents or to
                    help you pick up where you left off in a survey. If you have
                    Cookies disabled you may not be able to participate in some
                    surveys.
                </p>
                <h3>Research and Measurement Activities</h3>
                <p>
                    Information that we collect about you may be combined by us
                    with other information available to us through third parties
                    for research and measurement purposes, including measuring
                    the effectiveness of content, advertising or programs. This
                    information from other sources may include age, gender,
                    demographic, geographic, personal interests, product
                    purchase activity or other information. We may report
                    aggregate information, which is not able to be identified
                    back to an individual user of the HabitNu Site, to our
                    current or prospective advertisers and other business
                    partners. We do not sell or share any Personal Information
                    with any third parties, except contractors performing
                    services on our behalf who agree not to use this information
                    received from us for any purpose other than performing
                    services on our behalf.
                </p>
                <h3>With Whom Do We Share Your Information?</h3>
                <p>
                    Except as described in this Privacy Policy or as
                    specifically agreed to by you, Prana Diabetes will not
                    disclose any Personal Information it gathers from you
                    through the HabitNu Site. We may only release Personal
                    Information to third parties: (1) to comply with legal
                    requirements such as a law, regulation, search warrant,
                    subpoena or court order; or (2) in special cases, such as in
                    response to a physical threat to you or others, to protect
                    property or defend or assert legal rights. In addition, we
                    may disclose Personal Information as described below.
                </p>
                <p>
                    In the event of a corporate change in control resulting
                    from, for example, a sale to, or merger with, another
                    entity, or in the event of a sale of assets or a bankruptcy,
                    we reserve the right to transfer your Personal Information
                    to the new party in control or the party acquiring assets.
                    In the event of such a change, your Personal Information
                    will continue to be treated in accordance with this Privacy
                    Policy unless any changes to the Privacy Policy are made in
                    accordance with the section below that discusses "Changes to
                    This Privacy Policy."
                </p>
                <h3>Disclosures to Operations and Maintenance Contractors</h3>
                <p>
                    Our operations and maintenance contractors sometimes have
                    limited access to your Personal and Non-Personal Information
                    in the course of providing products or services to us. These
                    contractors include vendors and suppliers that provide us
                    with technology, services, data analysis, research,
                    advertising and marketing assistance and/or content for the
                    operation and maintenance of the HabitNu Site. We
                    contractually require that our operations and maintenance
                    contractors: 1) protect the privacy of your Personal and
                    Non-Personal Information consistent with this Privacy Policy
                    and 2) not use or disclose your Personal or Non-Personal
                    Information for any purpose other than providing the limited
                    service or function for Prana Diabetes.
                </p>
                <h3>Disclosures to Third Party Web Sites</h3>
                <p>
                    Certain content, services and advertisements offered to you
                    through the HabitNu Site are served on, or contain links to,
                    web sites hosted and operated by a company other than Prana
                    Diabetes ("Third Party Web Sites"). We do not disclose your
                    Personal Information to these Third Party Web Sites without
                    your consent, but you should be aware that any information
                    you disclose to the other web sites once you access these
                    other web sites is not subject to this Privacy Policy. Prana
                    Diabetes does not endorse and is not responsible for the
                    privacy practices of these Third Party Web Sites. You should
                    review the privacy policy posted on the other web site to
                    understand how that Third Party Web Site collects and uses
                    your Personal Information. We make an effort to make it
                    obvious to you when you leave our Site and enter a Third
                    Party Web Site, either by requiring you to click on a link
                    or by notifying you on the Site before you visit the third
                    party site. In addition, if you see a phrase such as
                    "Powered by" or "in association with" followed by the name
                    of a company other than Prana Diabetes, then you are on a
                    web site hosted by a company other than Prana Diabetes.
                </p>
                <h3>How Do We Secure and Retain Your Information?</h3>
                <p>
                    We take reasonable electronic and managerial security
                    measures to protect the security of your Personal
                    Information both during transmission and after we receive
                    it. Despite our efforts to protect your Personal
                    Information, there is always some risk that an unauthorized
                    third party may find a way around our security systems or
                    that transmissions of your information over the Internet may
                    be intercepted. We cannot, therefore, guarantee the security
                    of your Personal Information. For this reason, we recommend
                    that you use anti-virus software and firewalls, conduct
                    routine credit checks and use other precautions to protect
                    yourself from security and privacy threats.
                </p>
                <p>
                    The security of your Personal Information is important to
                    us. When you enter Personal Information (including personal
                    health information in various tools on our website), we
                    encrypt the transmission of that information or use SSL
                    connections (Secure Socket Layer) technology.
                </p>
                <p>
                    We will retain your Personal Information as long as your
                    account is active or needed to provide you services. At any
                    time you can remove your Personal Information or instruct us
                    to remove it, but you should be aware that it is not
                    technologically possible to remove each and every record of
                    the information you have provided to us from our servers.
                    The tools on our Site that collect and store Personal
                    Information allow you to correct, update or review
                    information you have submitted by going back to the specific
                    tool, logging-in and making the desired changes. We will
                    also retain your Personal Information as necessary to comply
                    with legal obligations, resolve disputes and enforce our
                    agreements.
                </p>
                <h3>Children</h3>
                <p>
                    We are committed to protecting the privacy of children. The
                    HabitNu Site is not designed or intended to attract children
                    under the age of 13. The HabitNu Site does not collect
                    Personal Information from any person we actually know is
                    under the age of 13. A parent or guardian, however, may use
                    the Site to register a minor. The parent or guardian is
                    solely responsible for providing supervision of the minor's
                    use of the HabitNu Site. The parent or guardian assumes full
                    responsibility for ensuring that the registration
                    information is kept secure and that the information
                    submitted is accurate. The parent or guardian also assumes
                    full responsibility for the interpretation and use of any
                    information or suggestions provided through our Site for the
                    minor.
                </p>
                <h3>
                    Contacting Us About Your Personal Information or Privacy
                </h3>
                <p>
                    Please send us an email by using the "Contact" page of the
                    Site if you have any questions about this Privacy Policy or
                    the Personal Information we maintain about you.{" "}
                    <a href="https://app.habitnu.com/feedback">
                        Here is the "Contact" page
                    </a>{" "}
                    as of September 18, 2016.
                </p>
                <h3>Changes to This Privacy Policy</h3>
                <p>
                    We reserve the right to change or modify this Privacy Policy
                    or any of our tools or services at any time and any changes
                    will be effective upon being posted unless we advise
                    otherwise. Any changes or modifications will become
                    effective upon posting. We encourage you to periodically
                    review the Privacy Policy. If you do not accept the terms of
                    this Privacy Policy, we ask that you do not register with us
                    and that you do not use the Site. Please exit the HabitNu
                    Site immediately if you do not agree to the terms of this
                    Privacy Policy.
                </p>
                <p> </p>
                <blockquote>Last Updated: September 18, 2016</blockquote>
                <br />
                <p className="text-center mt-2">
                    <a href="/">Login</a>
                </p>
            </Layout>
        );
    }
}
